// extracted by mini-css-extract-plugin
export default {"FavoritesPushHp":"bvryj","FavoritesPushHpIti":"tMkA3","FavoritesPushTitle":"js2m7"};